
























import Vue from 'vue'
import { TopPageIndustry } from '@/common/types'
import { topIndustries } from '@/top/data/industries'
import { SVG_PLACEHOLDER_IMAGES } from '@/common/constants'
import BaseImage from '@/common/components/BaseImage.vue'

export default Vue.extend({
  components: { BaseImage },
  computed: {
    industries(): TopPageIndustry[] {
      return topIndustries
    },
    placeholder(): string {
      return SVG_PLACEHOLDER_IMAGES.SQUARE
    }
  }
})
